import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  user: redukers.value({
    set: actionTypes.SET_USER,
    reset: actionTypes.LOGOUT,
  }),
  token: redukers.value({
    set: actionTypes.SET_TOKEN,
    reset: actionTypes.LOGOUT,
  }),
})
